import React from 'react';

import Image from 'next/image';

import { Button, Typography } from '@mui/material';
import classNames from 'classnames';

import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';

import styles from './HAListingsBanner.module.css';
import HALogo from './images/haLogo.webp';
import {
  AffiliateCitiesHA,
  AffiliateCitiesHACTATranslations,
  AffiliateCitiesHASubtitleTranslations,
  AffiliateCitiesHATitleTranslations,
} from './translations';

export const HAListingsBanner = () => {
  const { listingsState } = ListingsContext.useContext();
  const currentCity =
    listingsState.filterResult.filters.location?.cityName ?? '';
  const isHAPromoted = Object.values(AffiliateCitiesHA).includes(
    currentCity as AffiliateCitiesHA,
  );
  const { T } = useIntl();

  const cityClassname = currentCity.toLowerCase();

  let haRedirectLink = '#';

  if (isHAPromoted) {
    haRedirectLink = `https://housinganywhere.com/s/${currentCity}--Netherlands?utm_source=Kamernet&utm_medium=Banner&utm_campaign=affiliate_track&utm_content=Affiliate%20banner%20${currentCity}`;
  }

  return (
    <div>
      {isHAPromoted && (
        <div
          className={classNames(
            styles.root,
            styles[cityClassname as keyof typeof styles],
          )}
        >
          <div className={styles.card}>
            <Image
              className={CommonStyles.margin_bottom_1}
              src={HALogo.src}
              width={114}
              height={32}
              alt="HousingAnywhere"
            />
            <Typography variant="body3Bold">
              {T(
                AffiliateCitiesHATitleTranslations[
                  currentCity as AffiliateCitiesHA
                ],
              )}
            </Typography>
            <Typography variant="body3">
              {T(
                AffiliateCitiesHASubtitleTranslations[
                  currentCity as AffiliateCitiesHA
                ],
              )}
            </Typography>
            <Button
              className={CommonStyles.margin_top_2}
              variant="contained"
              color="secondary"
              href={haRedirectLink}
              target="_blank"
            >
              {T(
                AffiliateCitiesHACTATranslations[
                  currentCity as AffiliateCitiesHA
                ],
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
